import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from 'react';
import apiRequest from '../../functions/api';
import { Paper, Typography,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Grid} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
function Represent(props) {
  const { t } = useTranslation();
  const { accessToken,  client} = props;
  const {showErrorMessage, hideMessage} = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [vertretungen, setVertretungen] = useState([]);
  const ladeVertretungen = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "PMVER0",
      "statement": "VERTRETUNGEN_LADEN",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, vertretungenCb);
  }
  useEffect(() => {
    ladeVertretungen();
    // eslint-disable-next-line
  }, [])
 
  const vertretungenCb = (response) => {
    if (response.status === 200) {
        if (response.data.vertretungen) {
          setVertretungen(response.data.vertretungen);
        } else {
          setVertretungen([]);
        }
        setIsLoading(false);
        hideMessage();
    } else {
        if (response) {
          showErrorMessage(response.data.message);
          setIsLoading(false);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
          setIsLoading(false);
        }
    }      
}
  if (isLoading) {
    return <LoadingComponent />
  }
  const dataRequest = (vertretungen.length>0) ? vertretungen.map((element) => {
    return (
      <TableRow>
          <TableCell>{element.zeitraum}</TableCell>
          <TableCell>{element.name}</TableCell>
       </TableRow>
    )
    })
    :
    <TableRow>
      <TableCell colSpan={3}>
        <Typography variant="body1">{t("Es wurden keine aktiven Vertretungen gefunden")}</Typography>
      </TableCell>
    </TableRow>
    ;
      return (
        <div>
          <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
          <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={12}>
          <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("Zeitraum")}</TableCell>
                <TableCell>{t("Vertretung für")}</TableCell>
              </TableRow>
             </TableHead>           
            <TableBody>
              { dataRequest }         
            </TableBody> 
            </Table>
            </TableContainer>
            </Grid>
            </Grid>
            </Grid> 
            </Grid>       
        </div>
      );  
}
export default Represent;
